<template>
  <section class="page-otcDetailOrder a-5-bg" ref="content">
    <vue-scroll>
      <div class="page-otcDetailOrder-bar">
        <Title :isReady="isReady" :commonData="commonData" @getData="getData" ref="title" />
        <Message
          :isReady="isReady"
          @update:identificationShow="identificationShow = true"
          :commonData="commonData"
          @userNameClicked="onUserNameClicked"
        />
        <div class="otcDetailOrder-options">
          <Pays
            :isReady="isReady"
            :commonData="commonData"
            :payObj="payObj"
            @setPayObj="setPayObj"
          />
          <div class="otcDetailOrder-buttons" v-if="orderIsReady">
            <!-- 买1 -->
            <div class="buttonArea" v-if="status === '1' && commonData.side === 'BUY'">
              <!-- 取消订单 -->
              <c-button
                paddingW="40px"
                type="hollow"
                height="40px"
                class="buttonClass gray-10-bg gray-cl"
                @click="cancelOrderClick"
              >
                {{ $t("otcDetailOrder.CancellationOrder") }}
              </c-button>
              <!-- 去支付 -->
              <c-button
                class="buttonClass"
                paddingW="40px"
                :disabled="goPayDisabled"
                @click="goPayClick"
              >
                {{ $t("otcDetailOrder.goPay") }}
              </c-button>
            </div>
            <!-- 卖1 -->
            <div class="buttonArea" v-if="status === '1' && commonData.side === 'SELL'">
              <!-- 待买家付款 -->
              <c-button class="buttonClass" paddingW="40px" :disabled="true">
                {{ $t("otcDetailOrder.WaitingPayment") }}
              </c-button>
            </div>
            <!-- 买2/卖2 -->
            <div class="buttonArea" v-if="status === '2'">
              <!-- 待卖家放币 -->
              <c-button
                class="buttonClass"
                paddingW="40px"
                :disabled="true"
                v-if="commonData.side === 'BUY'"
              >
                {{ $t("otcDetailOrder.WaitingPuttingMoney") }}
              </c-button>
              <!-- 确认收款并放币 -->
              <c-button
                class="buttonClass"
                paddingW="40px"
                @click="releaseClick"
                v-if="commonData.side === 'SELL'"
              >
                {{ $t("otcDetailOrder.ConfirmReleaseMoney") }}
              </c-button>
              <!-- 提交申诉 -->
              <c-button
                paddingW="40px"
                height="40px"
                class="buttonClass"
                @click="appealClick"
                :disabled="enableComplainTimeLimit>0"
              >
                <span v-if="enableComplainTimeLimit>0">{{ countDownTimeFormat }} </span>
                <span>{{ $t("otcDetailOrder.SubmitAcomplaint") }}</span>
              </c-button>
            </div>
            <!-- 买3/卖3 买8/卖8 -->
            <div class="buttonArea" v-if="status === '3' || status === '8'">
              <!-- 返回法币大厅 -->
              <c-button class="buttonClass" paddingW="40px" @click="goHall">
                {{ $t("otcDetailOrder.goHall") }}
              </c-button>
              <!-- 提交申诉 -->
              <c-button
                paddingW="40px"
                height="40px"
                class="buttonClass"
                v-if="axiosData.complainExpireTime-Date.parse(new Date()) > 0"
                @click="appealClick"
              >
                {{ $t("otcDetailOrder.SubmitAcomplaint") }}
              </c-button>
            </div>
            <!-- 买4/卖4 -->
            <div class="buttonArea" v-if="status === '4' || status === '9' || status === '10' || status === '11'">
              <!-- 订单已关闭 -->
              <c-button class="buttonClass" paddingW="40px" :disabled="true">
                {{ $t("otcDetailOrder.OrderClosed") }}
              </c-button>
              <!-- 提交申诉 -->
              <!-- 11 超时取消 -->
              <c-button
                paddingW="40px"
                height="40px"
                class="buttonClass"
                v-if="status === '11' && axiosData.complainExpireTime-Date.parse(new Date()) > 0"
                @click="appealClick"
              >
                {{ $t("otcDetailOrder.SubmitAcomplaint") }}
              </c-button>
            </div>
            <!-- 买5/卖5 -->
            <div class="buttonArea" v-if="status === '5'">
              <!-- 订单申诉中 -->
              <c-button class="buttonClass" paddingW="40px" :disabled="true">
                {{ $t("otcDetailOrder.OrdersAppeal") }}
              </c-button>
              <!-- 取消申诉 -->
              <c-button
                paddingW="40px"
                height="40px"
                v-if="axiosData.isComplainUser.toString() === '1'"
                class="buttonClass"
                @click="cancelAppealClick"
              >
                {{ $t("otcDetailOrder.CancellationComplaint") }}
              </c-button>
            </div>
            <!-- 买7/卖7 -->
            <div class="buttonArea" v-if="status === '7'">
              <!-- 订单异常 -->
              <c-button class="buttonClass" paddingW="40px" :disabled="true">
                {{ $t("otcDetailOrder.OrderException") }}
              </c-button>
            </div>
          </div>
          <!-- <c-otcReminder :width="showChatDialog?'600px':'100%'" /> -->
        </div>
        <!-- 聊天 -->
        <chatVue v-show="showChatDialog" :chatTop="chatTop" :isReady="isReady" :commonData="commonData" />
        <c-alert :showFlag="false" :imgMap="imgMap" />
        <div class="maxEvmAll u-7-bg" v-if="maxEvmFlag" @click="maxEvm(false)"></div>
        <div class="maxEvm h-2-bg" v-if="maxEvmFlag" @click="maxEvm(false)">
          <img :src="payObj.qrcodeImg" />
        </div>

        <!-- 确认付款弹窗 -->
        <c-dialog
          :showFlag="goPayFlag"
          :titleText="$t('otcDetailOrder.ConfirmPayment')"
          :confirmText="$t('otcDetailOrder.MarkedAsPaid')"
          :closeText="$t('otcDetailOrder.NotYetPaid')"
          @close="goPayClose"
          @confirm="gopayConfirm"
          :confirmLoading="gopayConfirmLoading"
          paddingTop="24px"
          paddingBottom="0"
        >
          <div class="goPayDialog">
            <div class="warningText red-cl">
              <svg-icon class="icon icon-14" icon-class="warningIcon"></svg-icon>
              <!-- 本平台不支持自动扣款，请您本人向以上账号自行转账 -->
              <span>{{ $t("otcDetailOrder.payWarning") }}</span>
            </div>
            <div class="infoItemList">
              <!-- 支付金额 -->
              <div class="infoItem totalPayItem">
                <div class="label gray-cl">{{ $t("otcDetailOrder.PaymentAmount") }}</div>
                <div class="value blue-cl">{{ goPayText.price }}</div>
              </div>
              <!-- 对方支付方式 -->
              <div class="infoItem">
                <div
                  v-if="payObj.payment === 'otc.payment.domestic.bank.transfer'"
                  class="label gray-cl"
                >
                  {{ $t('fiatdeal.center.payment') }} ({{ payObj.name }})
                </div>
                <div
                  v-else
                  class="label gray-cl"
                >
                  {{ $t('fiatdeal.center.payment') }} ({{ payObj.name }}-{{ thirdPartyName(payObj.accountType) }})
                </div>
                <div class="value main-cl">
                  <!-- 微信/支付宝 -->
                  <div class="value-text" v-if="payObj.payment === 'otc.payment.alipay' || payObj.payment === 'otc.payment.wxpay'">
                    <span class="text-item">{{ payObj.userName }}</span>
                    <span class="text-item">{{ payObj.account }}</span>
                  </div>
                  <!-- 银行卡 -->
                  <div class="value-text blue-cl" v-else-if="payObj.payment === 'otc.payment.domestic.bank.transfer'">
                    <div class="text-item">{{$t('personal.setUp.paymentMethods.paymentsCard.name')}}: {{ payObj.userName }}</div>
                    <div class="text-item">{{$t('personal.setUp.paymentMethods.paymentsCard.account')}}: {{ payObj.account }}</div>
                    <div class="text-item">{{$t('personal.setUp.paymentMethods.paymentsCard.bank')}}: {{ payObj.bankName }}</div>
                    <div class="text-item">{{$t('personal.setUp.paymentMethods.paymentsCard.branchInfo')}}: {{ payObj.bankOfDeposit }}</div>
                  </div>
                  <!-- 其他 -->
                  <div class="value-text blue-cl" v-else>
                    <div class="text-item">
                      {{$t('personal.setUp.paymentMethods.paymentsCard.name')}}: {{ payObj.userName }}
                    </div>
                    <div class="text-item">
                      {{$t('personal.setUp.paymentMethods.paymentsWA.title')}}: {{ payObj.account }}
                    </div>
                  </div>
                </div>
              </div>
              <!-- 付款参考号 -->
              <!-- <div class="infoItem">
                <div class="label gray-cl">{{ $t("otcDetailOrder.PaymentReference") }}</div>
                <div class="value main-cl">{{ goPayText.id }}</div>
              </div> -->
            </div>
            <div v-if="payObj.qrcodeImg" class="qrcodeShow">
              <img :src="payObj.qrcodeImg" alt="">
            </div>
          </div>
        </c-dialog>

        <!-- 确认收款并放币 弹窗 -->
        <c-dialog
          :showFlag="releaseFlag"
          :titleText="$t('otcDetailOrder.ConfirmReleaseMoney')"
          paddingTop="24px"
          @confirm="releaseConfirm"
          @close="releaseClose"
          :confirmDisabled="releaseConfirmDisbale"
          :confirmLoading="releaseConfirmLoading"
        >
          <div class="releaseDialog">
            <div class="warningText red-cl">
              <svg-icon class="icon icon-14" icon-class="warningIcon"></svg-icon>
              <!-- 请务必登录账号确认收到该笔款项 -->
              <span>{{ $t("otcDetailOrder.ConfirmReleaseMoneyWarning") }}</span>
            </div>
            <!-- 资金密码 -->
            <!-- <c-inputLine
              :promptText="$t('otcDetailOrder.pass')"
              inputType="password"
              name="passValue"
              :value="passValue"
              marginTop="10px"
              :errorHave="true"
              :errorFlag="passErrorFlag"
              :errorText="$t('otcDetailOrder.passError')"
              @onchanges="inputLineChange"
              newStyleFormat
            /> -->
            <div class="passValueText">
              <c-checkBox :value="passCheck" @click="passCheckClick" />&nbsp;
              <!-- 我确认已登录收款账户，并核对收款无误 -->
              <span class="passValueText-text" @click="passCheckClick">
                {{ $t("otcDetailOrder.ConfirmReleaseMoneyConfrim") }}</span
              >
            </div>
          </div>
        </c-dialog>

        <!-- 取消订单 弹窗 -->
        <c-dialog
          :showFlag="cancelOrderFlag"
          :titleText="$t('otcDetailOrder.CancellationOrderTitle')"
          paddingTop="20px"
          @close="cancelOrderClose"
          @confirm="cancelOrderConfirm"
          :confirmLoading="cancelOrderLoading"
          :confirmDisabled="cancelOrderConfirmDisabled"
        >
          <div class="cancelOrderDialog">
            <ul>
              <!-- 取消订单后不会退款，如您已付款，请勿取消订单。 -->
              <li>{{ $t("otcDetailOrder.CancellationOrderWarning1") }}</li>
              <!-- 取消规则：买方访日累计取消3笔订单，将会限制当日买入功能 -->
              <li>{{ $t("otcDetailOrder.CancellationOrderWarning2") }}</li>
            </ul>
            <div class="cancelOrderDialog-check">
              <!-- 我确定还没付款给对方 -->
              <c-checkBox :value="cancelOrderCheck" @click="cancelOrderCheckClick" />&nbsp;
              <span class="cancelOrderDialog-check-text" @click="cancelOrderCheckClick">
                {{ $t("otcDetailOrder.CancellationOrderConfrim") }}</span
              >
            </div>
          </div>
        </c-dialog>

        <!-- 申诉 弹窗 -->
        <c-dialog
          :showFlag="appealFlag"
          :titleText="$t('otcDetailOrder.AppealTitle')"
          paddingTop="20px"
          @close="appealClose"
          @confirm="appealConfirm"
          :confirmLoading="appealLoading"
          :confirmDisabled="appealConfirmDisabled"
        >
          <div class="appealDialog">
            <div class="warningText red-cl">
              <svg-icon class="icon icon-14" icon-class="warningIcon"></svg-icon>
              <!-- 如果订单遇到纠纷，可以通过申诉渠道解决。 -->
              <span>{{ $t("otcDetailOrder.AppealWarning") }}</span>
            </div>
            <!-- 申诉理由 -->
            <c-textAreaLine
              :promptText="$t('otcDetailOrder.ReasonsAppeal')"
              name="appealValue"
              :value="appealValue"
              marginTop="24px"
              @onchanges="inputLineChange"
              maxLength="200"
              :warningText="`${appealValue.length}/200`"
              :errorHave="true"
            />
          </div>
        </c-dialog>

        <!-- 取消申诉 弹窗 -->
        <c-dialog
          :showFlag="cancelAppealFlag"
          :titleText="$t('otcDetailOrder.CancellationComplaintTitle')"
          paddingTop="40px"
          @close="cancelAppealClose"
          @confirm="cancelAppealConfirm"
          :confirmLoading="cancelAppealLoading"
        >
          <div class="cancelAppealDialog">
            <!-- 取消申诉代表您对此订单无争议，您确定取消申诉吗？ -->
            {{ $t("otcDetailOrder.CancellationComplaintConfrim") }}
          </div>
        </c-dialog>
        <!-- 联系方式 -->
        <c-dialog
          :titleText="$t('otcDetailOrder.connection')"
          :showFlag="identificationShow"
          @close="identificationShow = false"
          @confirm="identificationShow = false"
          class="connection-dialog"
        >
          <ul class="connection-list" v-if="identificationInfo.isTwoMin">
            <li class="connection-li a-4-bg" v-if="identificationInfo.mobileNumber">
              <p class="connection-title b-2-cl">{{ $t("otcDetailOrder.phone") }}</p>
              <p class="connection-desc b-1-cl">{{ identificationInfo.mobileNumber }}</p>
            </li>
            <li class="connection-li a-4-bg" v-if="identificationInfo.email">
              <p class="connection-title b-2-cl">{{ $t("register.email") }}</p>
              <p class="connection-desc b-1-cl">{{ identificationInfo.email }}</p>
            </li>
          </ul>
          <p class="towMin" v-else>{{ $t("otcDetailOrder.twoMin") }}</p>
        </c-dialog>
      </div>
    </vue-scroll>
  </section>
</template>
<script>
import { fixD, imgMap, colorMap } from '@/utils';
import Title from './title.vue';
import Message from './message.vue';
import Pays from './pays.vue';
import chatVue from './chat.vue';

export default {
  components: {
    Title,
    Message,
    Pays,
    chatVue,
  },
  data() {
    return {
      timer: null,
      orderIsReady: false,
      orderId: '',
      axiosData: {},
      payObj: {}, // 买家支付时，选择的支付方式对象
      cancelOrderFlag: false, // 取消订单 开关变量 -- 用于买1
      cancelOrderCheck: false, // 取消订单 checkout
      cancelOrderLoading: false, // 取消订单 loading
      goPayFlag: false, // 确认付款弹窗 开关变量 -- 用于买1
      gopayConfirmLoading: false, // 确认付款弹窗 -- loading 用于买1
      releaseFlag: false, // 确认放行弹窗 开关变量
      passValue: '', // 资金密码 -- 用于卖2
      passCheck: false, // 资金密码 checkout -- 用于卖2
      releaseConfirmLoading: false, // 确认放币弹窗 确认按钮loading -- 用于卖2
      appealFlag: false, // 申诉弹窗 -- 用于买2/卖2
      appealValue: '', // 申诉内容 -- 用于买2/卖2
      appealLoading: false, // 申诉弹窗 确认按钮loading -- 用于买2/卖2
      cancelAppealFlag: false, // 取消申诉弹窗
      cancelAppealLoading: false, // 取消申诉的loading
      chatTop: 0,
      // chatHeight: 0,
      maxEvmFlag: false,
      imgMap,
      colorMap,
      identificationShow: false,
      showChatDialog: true,
      enableComplainTimeLimit: 0,
    };
  },
  watch: {
    status(v) {
      if (v) {
        this.$nextTick(() => {
          const { title } = this.$refs;
          this.chatTop = title.$el.offsetHeight;
        });
      }
    },
  },
  computed: {
    getAccountType(payObj) {
      if (!this.payObj || !this.payObj.accountType) return '';
      const accountType = this.payObj.accountType;
      const arr = accountType.split('.');
      return arr[arr.length - 1];
    },
    /**
     * 倒计时展示
     */
    countDownTimeFormat() {
      if (this.enableComplainTimeLimit <= 0) {
        return '00:00';
      }

      // 将毫秒数转换为秒数
      const seconds = Math.floor(this.enableComplainTimeLimit / 1000);

      // 计算分钟数
      const minutes = Math.floor(seconds / 60);

      // 计算剩余秒数
      const remainingSeconds = seconds % 60;

      // 输出倒计时时间
      return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
    },

    identificationInfo() {
      const obj = {};
      const sideMap = {
        SELL: 'buyer',
        BUY: 'seller',
      };
      if (this.commonData.side) {
        const commonData = this.commonData[sideMap[this.commonData.side]];
        if (commonData) {
          obj.realName = commonData.realName;
          obj.mobileNumber = commonData.mobileNumber;
          obj.email = commonData.email;
          obj.isTwoMin = Number(this.commonData.isTwoMin);
        }
      }
      return obj;
    },

    goPayText() {
      let price = '';
      let id = '';
      const { sequence, totalPrice, paycoin } = this.commonData;
      if (sequence) {
        id = sequence.substring(sequence.length - 6);
      }
      if (totalPrice && paycoin) {
        price = `${totalPrice} ${paycoin}`;
      }
      return {
        id,
        price,
      };
    },

    // buy 1 去支付按钮 disabled
    goPayDisabled() {
      let flag = false;
      if (this.payObj.payment) {
        flag = false;
      }
      return flag;
    },

    // 资金密码 是否复合正则验证 卖2
    passFlag() {
      return this.$store.state.regExp.passWord.test(this.passValue);
    },
    // 资金密码 是否为错误状态 卖2
    passErrorFlag() {
      if (this.passValue.length !== 0 && !this.passFlag) return true;
      return false;
    },
    // 确认放币弹窗 确定按钮 禁用  卖2
    releaseConfirmDisbale() {
      const flag = false;
      if (!this.passCheck) return true;
      // if ((this.passCheck && this.passFlag) || this.releaseConfirmLoading) {
      //   flag = false;
      // }
      return flag;
    },
    // 申诉弹窗 确定按钮 禁用 买2/卖2
    appealConfirmDisabled() {
      let flag = true;
      if (this.appealValue.length || this.appealLoading) {
        flag = false;
      }
      return flag;
    },
    // 取消订单 确定按钮 禁用
    cancelOrderConfirmDisabled() {
      let flag = true;
      if (this.cancelOrderCheck || this.cancelOrderLoading) {
        flag = false;
      }
      return flag;
    },
    status() {
      if (this.commonData.status) {
        return this.commonData.status.toString();
      }
      return '0';
    },
    baseData() {
      return this.$store.state.baseData;
    },
    userInfo() {
      return this.$store.state.baseData.userInfo;
    },
    isLogin() {
      return this.$store.state.baseData.isLogin;
    },
    // 传给子组件是否准备就绪 必须订单接口和user_info请求成功
    isReady() {
      let flag = false;
      if (this.isLogin && this.orderIsReady) {
        flag = true;
      }
      return flag;
    },
    // 传给子组件的数据 axios返回的订单数据 + 自己算出的方向
    commonData() {
      let obj = {};
      if (this.isReady) {
        if (this.userInfo.id && this.axiosData.seller && this.axiosData.seller.uid) {
          const side = this.userInfo.id.toString() === this.axiosData.seller.uid.toString() ? 'SELL' : 'BUY';
          obj = { ...this.axiosData, ...{ side } };
        }
      }
      return obj;
    },
    market() {
      return this.$store.state.baseData.market;
    },
    priceFix() {
      let fix = this.$store.state.baseData.defaultFiatPrecision;
      const { coin, paycoin } = this.commonData;
      if (
        this.market
        && this.market.coinList[coin]
        && this.market.coinList[coin].fiatPrecision
        && this.market.coinList[coin].fiatPrecision[paycoin.toLowerCase()]
      ) {
        fix = this.market.coinList[coin].fiatPrecision[paycoin.toLowerCase()];
      }
      return Number(fix);
    },
    volumeFix() {
      let fix = '';
      const { coin } = this.commonData;
      if (
        this.market
        && coin
        && this.market.coinList[coin]
        && this.market.coinList[coin].showPrecision
      ) {
        fix = this.market.coinList[coin].showPrecision;
      }
      return Number(fix);
    },
    thirdPartyPayments() {
      const otcPublicInfo = this.$store.state.baseData.otcPublicInfo;
      return otcPublicInfo ? otcPublicInfo.thirdPartyPayments : null;
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  mounted() {
    this.init();
  },
  methods: {
    onUserNameClicked() {
      this.showChatDialog = !this.showChatDialog;
    },
    init() {
      const { orderId } = this.$route.query;
      if (orderId) {
        this.orderId = orderId;
        this.getData();
      }
      this.$store.dispatch('getOtcPublicInfo');
    },
    maxEvm(v) {
      this.maxEvmFlag = v;
    },
    getData() {
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.initOrder(true);
      }, 10000);
      this.$nextTick(() => {
        this.initOrder();
      });
    },
    // 获取订单数据
    initOrder(auto) {
      const headers = {};
      if (auto) {
        headers['exchange-auto'] = '1';
      }
      this.axios({
        url: 'v4/otc/order_detail',
        params: {
          sequence: this.orderId,
          headers,
        },
        hostType: 'otc',
      }).then((data) => {
        if (data.code.toString() === '0') {
          this.orderIsReady = true;
          this.axiosData = data.data;
          this.axiosData.price = fixD(this.axiosData.price, this.priceFix);
          this.axiosData.totalPrice = fixD(this.axiosData.totalPrice, this.priceFix);
          this.axiosData.volume = fixD(this.axiosData.volume, this.volumeFix);
          this.enableComplainTimeLimit = this.axiosData.enableComplainTimeLimit || 0;
          if (this.enableComplainTimeLimit > 0) {
            this.startCountDown();
          }
        } else {
          this.$bus.$emit('tip', { text: data.msg, type: 'error' });
        }
      });
    },

    /**
     * 开始倒计时
     */
    startCountDown() {
      if (this.countDownTimer) {
        clearTimeout(this.countDownTimer);
        this.countDownTimer = null;
      }

      this.countDownTimer = setTimeout(() => {
        this.enableComplainTimeLimit -= 1000;
        if (this.enableComplainTimeLimit > 0) {
          this.startCountDown();
        }
      }, 1000);
    },

    // 买家支付时，修改选择的支付方式对象
    setPayObj(v) {
      this.payObj = v;
    },
    // 买1 去支付按钮
    goPayClick() {
      if (!this.payObj.payment) {
        this.$bus.$emit('tip', { text: this.$t('otcDetailOrder.noPaymentErr'), type: 'error' });
        return;
      }
      this.goPayFlag = true;
    },
    // 买1 确认付款碳层 close
    goPayClose() {
      this.goPayFlag = false;
    },
    // 买1 标记为已付款 confirm
    gopayConfirm() {
      this.gopayConfirmLoading = true;
      this.axios({
        url: '/v4/otc/order_payed',
        hostType: 'otc',
        params: {
          sequence: this.orderId,
          payment: this.payObj.payment,
          paymentId: this.payObj.id,
        },
      }).then((data) => {
        this.gopayConfirmLoading = false;
        if (data.code.toString() === '0') {
          this.getData();
          this.$bus.$emit('tip', { text: data.msg, type: 'success' });
          this.goPayFlag = false;
        } else {
          this.$bus.$emit('tip', { text: data.msg, type: 'error' });
        }
      });
    },
    // 卖2 确认收款并放币
    releaseClick() {
      this.releaseFlag = true;
    },
    // 卖2 checkout点击
    passCheckClick() {
      this.passCheck = !this.passCheck;
    },
    // 卖2 关闭确认放行弹窗
    releaseClose() {
      this.releaseFlag = false; // 关闭弹窗
      this.passValue = ''; // 清空资金密码
      this.passCheck = false; // 取消checkout
    },
    // 卖2 确认放行弹窗 确定
    releaseConfirm() {
      this.releaseConfirmLoading = true;
      const url = 'otc/confirm_order';
      this.axios({
        url,
        hostType: 'otc',
        params: {
          sequence: this.orderId,
          // capitalPword: this.passValue,
        },
      }).then((data) => {
        this.releaseConfirmLoading = false;
        if (data.code.toString() === '0') {
          this.getData();
          this.$bus.$emit('tip', { text: data.msg, type: 'success' });
          this.releaseClose();
        } else {
          this.$bus.$emit('tip', { text: data.msg, type: 'error' });
        }
      });
    },
    // 申诉按钮点击 买2 / 卖2
    appealClick() {
      const nowTime = new Date().getTime();
      const spk = nowTime - this.axiosData.payTime;
      if (spk <= 300000) {
        // 确认付款5分钟后才可提交申诉
        this.appealFlag = true;
        // this.$bus.$emit('tip', {
        //   text: this.$t('otcDetailOrder.AppealTitleFive'),
        //   type: 'warning',
        // });
      } else {
        this.appealFlag = true;
      }
    },
    // 申诉弹窗 关闭按钮
    appealClose() {
      this.appealFlag = false;
      this.appealValue = '';
    },
    // 申诉弹窗 确认按钮
    appealConfirm() {
      this.appealLoading = true;
      this.axios({
        url: 'question/create_problem',
        params: {
          rqType: this.commonData.side === 'BUY' ? 8 : 9,
          rqDescribe: this.appealValue,
        },
      }).then((data) => {
        if (data.code.toString() === '0') {
          const url = 'otc/complain_order';
          this.axios({
            url,
            hostType: 'otc',
            params: {
              sequence: this.orderId,
              complainId: data.data.complainId,
            },
          }).then((cdata) => {
            this.appealLoading = false;
            if (cdata.code.toString() === '0') {
              this.getData();
              this.appealClose();
              this.$bus.$emit('tip', { text: cdata.msg, type: 'success' });
            } else {
              this.$bus.$emit('tip', { text: cdata.msg, type: 'error' });
            }
          });
        } else {
          this.appealLoading = false;
          this.$bus.$emit('tip', { text: data.msg, type: 'error' });
        }
      });
    },
    // 取消申诉 点击
    cancelAppealClick() {
      this.cancelAppealFlag = true;
    },
    // 取消申诉弹窗 关闭按钮
    cancelAppealClose() {
      this.cancelAppealFlag = false;
    },
    // 取消申诉弹窗 确定按钮
    cancelAppealConfirm() {
      this.cancelAppealLoading = true;
      const url = 'otc/complain_cancel';
      this.axios({
        hostType: 'otc',
        url,
        params: {
          sequence: this.orderId,
        },
      }).then((data) => {
        this.cancelAppealLoading = false;
        if (data.code.toString() === '0') {
          this.getData();
          this.$bus.$emit('tip', { text: data.msg, type: 'success' });
          this.cancelAppealClose();
        } else {
          this.$bus.$emit('tip', { text: data.msg, type: 'error' });
        }
      });
    },
    // ---------- 取消订单 -----------
    // 取消订单 click
    cancelOrderClick() {
      this.cancelOrderFlag = true;
    },
    // 取消订单 checkout点击
    cancelOrderCheckClick() {
      this.cancelOrderCheck = !this.cancelOrderCheck;
    },
    // 取消订单 弹窗关闭
    cancelOrderClose() {
      this.cancelOrderFlag = false;
      this.cancelOrderCheck = false;
    },
    // 取消订单 确认按钮
    cancelOrderConfirm() {
      this.cancelOrderLoading = true;
      const url = 'otc/order_cancel';
      this.axios({
        url,
        hostType: 'otc',
        params: {
          sequence: this.orderId,
        },
      }).then((data) => {
        this.cancelOrderLoading = false;
        if (data.code.toString() === '0') {
          this.getData();
          this.$bus.$emit('tip', { text: data.msg, type: 'success' });
          this.cancelOrderClose();
        } else {
          this.$bus.$emit('tip', { text: data.msg, type: 'error' });
        }
      });
    },
    inputLineChange(value, name) {
      this[name] = value;
    },
    // 前往广告大厅
    goHall() {
      this.$router.push('/otc');
    },
    thirdPartyName(key) {
      if (!this.thirdPartyPayments) return '';
      const thirdPartyInfo = this.thirdPartyPayments.filter(t => t.key === key);
      if (thirdPartyInfo && thirdPartyInfo.length) {
        return thirdPartyInfo[0].title;
      }
      return '';
    },
  },
};
</script>

<style lang="scss" scoped>
.page-otcDetailOrder {
  width: 100%;
  // min-height: 900px;
  padding-bottom: 40px;
  margin: 0 auto;
  position: relative;
  box-sizing: border-box;
  border-radius: 6px;
  .input-line-warning {
    right: 0;
  }

  .otcDetailOrder-options {
    padding: 24px;
  }

  .otcDetailOrder-buttons {
    margin-top: 80px;

    .buttonArea {
      display: flex;
      align-items: center;
      gap: 16px;

      .buttonClass {
        width: 260px;
        font-size: 16px;
      }
    }
  }

  .goPayDialog,
  .releaseDialog,
  .appealDialog {
    .text {
      font-size: 12px;
    }
  }

  .maxEvm {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1002;
    left: 50%;
    top: 50%;
    transform: translate3d(-50%, -50%, 0);
    padding: 10px;
    border-radius: 2px;
    img {
      min-width: 500px;
      max-width: 740px;
      min-height: 500px;
      max-height: 740px;
    }
  }

  .maxEvmAll {
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 1001;
    top: 0;
    left: 0;
  }

  .warningText {
    text-align: center;
    display: flex;
    gap: 6px;
    justify-content: center;
  }

  // 确认付款弹窗
  .goPayDialog {
    padding-bottom: 10px;

    .infoItemList {
      display: flex;
      padding: 32px;
      flex-direction: column;
      gap: 38px;

      .infoItem {
        display: flex;
        flex-direction: column;
        min-width: max-content;
        width: 104px;
        gap: 8px;
        font-size: 16px;
        align-items: flex-start;

        .label {
          // width: 102px;
        }

        .value {
          margin-left: 20px;
          margin-top: 10px;
          .value-text {
            display: flex;
            flex-direction: column;
            gap: 4px;
            flex-wrap: wrap;
            max-width: 400px;
          }
          .text-item {
            margin-bottom: 12px;
          }
        }
      }

      .totalPayItem {
        align-items: flex-start;

        .value {
          font-size: 30px;
        }
      }
    }

    .qrcodeShow {
      max-width: 200px;
      max-height: 325px;
      margin: 0 auto;
      overflow: auto;

      img {
        width: 100%;
      }
    }
  }

  // 确认收款并放币
  .releaseDialog {
    .passValueText {
      font-size: 14px;
      cursor: pointer;
      user-select: none;
      margin-top: 20px;
      .common-checkout {
        vertical-align: middle;
      }
      .passValueText-text {
        vertical-align: middle;
      }
    }
  }

  .connection-dialog {
    .towMin {
      padding-top: 10px;
      padding-bottom: 14px;
    }
  }

  .connection-list {
    text-align: left;
    .connection-li {
      width: 400px;
      height: 70px;
      margin-bottom: 1px;
    }
    .connection-title {
      letter-spacing: 0;
      line-height: 16px;
      padding-left: 20px;
      padding-top: 17px;
    }
    .connection-desc {
      margin-top: 7px;
      font-size: 16px;
      letter-spacing: 0;
      padding-left: 20px;
    }
  }
  // 申诉
  .appealDialog {
  }
  // 取消订单
  .cancelOrderDialog {
    li {
      font-size: 14px;
      margin-bottom: 2px;
      line-height: 22px;
    }
    .cancelOrderDialog-check {
      margin-top: 18px;
      font-size: 14px;
      cursor: pointer;
      user-select: none;
      .common-checkout {
        vertical-align: middle;
      }
      .cancelOrderDialog-check-text {
        vertical-align: middle;
      }
    }
  }

  // 取消申诉
  .cancelAppealDialog {
    font-size: 14px;
    padding-bottom: 10px;
  }
}
</style>
